import React from 'react'
import Container from '../../Container/Container'

function OrderReview() {
   return (
      <Container>
         <div class="nk-content ">
            <div class="container-fluid">
               <div class="nk-content-inner">
                  <div class="nk-content-body">
                     <div class="nk-block-head nk-block-head-sm">
                        <div class="nk-block-between">
                           <div class="nk-block-head-content">
                              <h3 class="nk-block-title page-title">Order Review</h3>
                           </div>
                        </div>
                     </div>
                     <div class="card card-full">
                        <div class="card-inner">
                           <div class="card-title-group mb-3">
                              <div class="card-tools">
                                 <div class="form-control-wrap">
                                    <h5 class="mb-0">Review order and book it</h5>
                                    <p>Order Type: Rental</p>
                                 </div>
                              </div>
                           </div>
                           <div className="row">
                              <div className="col-md-4 order-md-2">
                                 <div className="eventDetailBox">
                                    <div className="firstTitle">
                                       <p>Customer <span><small>Customer is tax-exempt</small></span></p>
                                    </div>
                                    <div className="row mt-2">
                                       <div className="col-md-12">
                                          <div className="row">
                                             <div className="col-md-6">
                                                <p><em class="icon ni ni-user-alt"></em> Alex Jander</p>
                                             </div>
                                             <div className="col-md-6">
                                                <p><em class="icon ni ni-bag"></em> 1 Order</p>
                                             </div>
                                          </div>
                                          <div className="col-md-12">
                                             <hr>
                                             </hr>
                                          </div>
                                          <div className="col-md-12">
                                             <p className="mb-1"><b>Length of Rental:</b> 1 Week</p>
                                             <p className="mb-1"><b>School name:</b>  St. Androld</p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="eventDetailBox">
                                    <div className="firstTitle">
                                       <p>Contact Information</p>
                                    </div>
                                    <div className="row mt-2">
                                       <div className="col-md-12">
                                          <div className="row">
                                             <div className="col-md-12">
                                                <p><em class="icon ni ni-user-alt"></em> alexjander@gmail.com</p>
                                             </div>
                                             <div className="col-md-12">
                                                <p><em class="icon ni ni-call"></em> +1 856-423-1230</p>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="eventDetailBox">
                                    <div className="firstTitle">
                                       <p>Alternate Pickup Location</p>
                                    </div>
                                    <div className="row mt-2">
                                       <div className="col-md-12">
                                          <div className="row">
                                             <div className="col-md-6">
                                                <p><em class="icon ni ni-user-alt"></em> Kurtis Tirevold</p>
                                             </div>
                                             <div className="col-md-6">
                                                <p><em class="icon ni ni-call"></em> (715) 235-0902</p>
                                             </div>
                                             <div className="col-md-12 mt-2">
                                                <p>1226 University Drive Menio Park CA 94025
                                                   United Stated
                                                </p>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-8 order-md-1">
                                 <div className="eventDetailBox">
                                    <div className="firstTitle">
                                       <p>Event date: Jan 31, 2025 <span>Type: Single</span></p>
                                    </div>
                                    <div className="row mt-2">
                                       <div className="col-md-3">
                                          <img src="assets/images/prom-ordereview.png" className="selectCoatImgReview" alt="" />
                                       </div>
                                       <div className="col-md-9">
                                          <div className="row">
                                             <div className="col-md-9">
                                                <h5 className="mb-0">Coat:</h5>
                                                <p>123 Denim Blue Allure Men Ridge Suit Notch 2B</p>
                                             </div>
                                             <div className="col-md-3">
                                                <h5 className="mb-0">Size:</h5>
                                                <p>38R</p>
                                             </div>
                                          </div>
                                          <div className="row mt-3">
                                             <div className="col-md-9">
                                                <h5 className="mb-0">Pant:</h5>
                                                <p>123 Denim Blue Allure Men Ridge Trouser</p>
                                             </div>
                                             <div className="col-md-3">
                                                <h5 className="mb-0">Waist:</h5>
                                                <p>33</p>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="eventDetailBox">
                                    <h5>Other detail</h5>
                                    <ul className="fstCategory">
                                       <li>
                                          <span>Hip:</span> 32
                                       </li>
                                       <li>
                                          <span>Outseam:</span> 26
                                       </li>
                                       <li>
                                          <span>Vest:</span> M191
                                       </li>
                                    </ul>
                                    <ul className="fstCategory">
                                       <li>
                                          <span>Shirt:</span> 310 White Microfiber Wing Collar
                                       </li>
                                    </ul>
                                    <ul className="fstCategory">
                                       <li>
                                          <span>Shoe:</span> BLMT Black Matte Finish Square Toe
                                       </li>
                                    </ul>
                                    <ul className="fstCategory">
                                       <li>
                                          <span>Neck-Sleeve:</span> 14 x 31 (S1)
                                       </li>
                                       <li>
                                          <span>Size:</span> 10.5 Regular
                                       </li>
                                    </ul>
                                    <ul className="fstCategory">
                                       <li>
                                          <span>Pocket Square:</span> H101 Gray Tweed
                                       </li>
                                       <li>
                                          <span>Jewelry:</span> B Black / Silver Basic
                                       </li>
                                    </ul>
                                 </div>
                                 <div className="eventDetailBox">
                                    <div className="row mt-2">
                                       <div className="col-md-12">
                                          <div className="row">
                                             <div className="col-md-9">
                                                <h5 className="mb-0">Comment</h5>
                                                <p>BLMIT 12M MY PSQ</p>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>

                                 <div class="col-md-12 mt-3">
                                    <a href='' className="backBtnWedding">Back</a>
                                    <button type="submit" class="addBtnCustomer">Confirm Order</button>
                                 </div>

                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </Container>
   )
}

export default OrderReview